<div class="print-main-container">
  @for (need of needsections?.needChng?.categories; track need) {
    <div class="print-section" >
      <div class="col-12 h2" [innerHTML]="need.title"></div>
      <hr />
      <div class="col-12 titl" [innerHTML]="need.body"></div>
      <ul></ul>
    </div>
  }
</div>
